"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var SortDescendingSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M4,4 L11,4 L11,7 L3,7 L3,5 C3,4.44771525 3.44771525,4 4,4 Z M4,5 L4,6 L10,6 L10,5 L4,5 Z M3,8 L9,8 L9,11 L3,11 L3,8 Z M4,9 L4,10 L8,10 L8,9 L4,9 Z M3,12 L7,12 L7,15 L4,15 C3.44771525,15 3,14.5522847 3,14 L3,12 Z M4,13 L4,14 L6,14 L6,13 L4,13 Z M15.8519116,12.1450118 C16.0403743,12.3389382 16.0387795,12.6480845 15.8483263,12.8400564 L13.5,15.2071068 L11.1520318,12.8447258 C10.9593048,12.6508158 10.9592321,12.3377007 11.1518691,12.1437012 C11.3434739,11.9507413 11.6552251,11.9496427 11.8481851,12.1412474 L13,13.2928932 L13,4 L14,4 L14,13.2928932 L15.1663258,12.1383705 C15.3557449,11.9508683 15.6612999,11.9524223 15.8488021,12.1418413 L15.8519116,12.1450118 Z" })));
};
SortDescendingSmall.displayName = 'SortDescendingSmall';
exports.default = SortDescendingSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=SortDescendingSmall.js.map